var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2401 28.343L26.8594 40.5991L17.7803 33.2223L21.5638 28.5656L26.2842 32.4009L33.8434 24.2603L38.2401 28.343Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 13.5L51 13.5V19.5L5 19.5L5 13.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02222 1.5L51.002 1.5L50.9778 37.0745C50.9778 37.0752 50.9778 37.0759 50.9778 37.0766C50.9771 39.6422 49.6488 41.8838 47.6867 43.1923L47.6763 43.1992L28.001 56.0855L8.30214 43.1996L8.29106 43.1923C6.32846 41.8834 5 39.641 5 37.0745L5.02427 1.5L8.02222 1.5ZM11.0202 7.5L11 37.0745C11 37.0743 11 37.0748 11 37.0745C11.0002 37.5157 11.2242 37.9328 11.612 38.1951L27.999 48.9145L44.3653 38.1954C44.7536 37.933 44.9778 37.5161 44.9778 37.0745L44.998 7.5L11.0202 7.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.d5de3e71c37761f4293d19ecedc7221c.svg";
export { ForwardRef as ReactComponent };